<div class="custom-mat-form-wrapper" [class.compact-field]="compact" [class.custom-input-number]="type === 'number'">
  <div class="mat-form-label" *ngIf="label">
    <ng-container *ngIf="state.labelTemplate; else defaultLabelTmpl">
      <ng-container *ngTemplateOutlet="state.labelTemplate"></ng-container>
    </ng-container>

    <ng-template #defaultLabelTmpl>
      <span>{{ label }}</span>
      <y42-icon *ngIf="tooltipHint" [icon]="'circle-info'" [matTooltip]="tooltipHint"></y42-icon>
    </ng-template>
  </div>

  <mat-form-field
    class="w-full"
    appearance="fill"
    subscriptSizing="dynamic"
    [color]="color"
    [matTooltip]="state.aclTooltip"
  >
    <ng-container matPrefix>
      <ng-content select="[y42InputPrefix]"></ng-content>
    </ng-container>

    <!-- https://github.com/angular/angular/issues/13243 -->
    <ng-container *ngIf="type === 'number'">
      <input
        autocomplete="off"
        matInput
        type="number"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [autocomplete]="autocomplete"
        [readOnly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        (input)="input.emit($event)"
      />
    </ng-container>

    <ng-container *ngIf="type === 'textarea'">
      <textarea
        autocomplete="off"
        matInput
        [type]="type"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [autocomplete]="autocomplete"
        [readOnly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        (input)="input.emit($event)"
      >
      </textarea>
    </ng-container>

    <ng-container *ngIf="type !== 'number' && type !== 'textarea'">
      <input
        autocomplete="off"
        matInput
        [type]="type"
        [formControl]="formCtrl"
        [placeholder]="placeholder ?? ''"
        [autocomplete]="autocomplete"
        [readOnly]="readOnly"
        [errorStateMatcher]="errorStateMatcher"
        [required]="required"
        [tabIndex]="tabIndex"
        (input)="input.emit($event)"
      />
    </ng-container>

    <ng-content></ng-content>
    <ng-container matSuffix>
      <ng-content select="[y42InputSuffix]"></ng-content>
      <ng-container *ngIf="enableCopyToClipboard">
        <y42-copy-to-clipboard *ngIf="formCtrl.value" [value]="formCtrl.value"></y42-copy-to-clipboard>
      </ng-container>
    </ng-container>
    <mat-error *ngIf="!hideErrors && state.errorMessage">
      {{ state.errorMessage }}
    </mat-error>
  </mat-form-field>
</div>
